import React from 'react';
import './AI_tools.css';
import Underline from '../Underline/Underline';

const AI_tools = ({ tool }) => {
  return (
    <div className="info-section">
      <Underline heading={tool.title} />

      {/* Description Section */}
      {tool.description?.heading && (
        <section>
          <h2 className="info-subheading">{tool.description.heading}</h2>
          <p className="info-paragraph">{tool.description.text}</p>
        </section>
      )}

      {/* Features Section */}
      {tool.features?.heading && tool.features?.list && (
        <section>
          <h2 className="info-subheading">{tool.features.heading}</h2>
          <ul className="info-list">
            {tool.features.list.map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ul>
        </section>
      )}

      {/* Benefits Section */}
      {tool.benefits?.heading && tool.benefits?.list && (
        <section>
          <h2 className="info-subheading">{tool.benefits.heading}</h2>
          <ul className="info-list">
            {tool.benefits.list.map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ul>
        </section>
      )}

      {/* Link Section */}
      {tool.link?.heading && tool.link?.url && (
        <section>
          <h2 className="info-subheading">{tool.link.heading}</h2>
          <a
            href={tool.link.url.trim()}
            target="_blank"
            rel="noopener noreferrer"
            className="info-link"
          >
            {tool.link.url.trim()}
          </a>
        </section>
      )}
    </div>
  );
};

export default AI_tools;
